import React from 'react';
import '../css/MainContent.css';
import laptop from '../assets/images/laptop.png';
//import smartphone from '../assets/images/smartphone.png';

function MainContent() {
  return (
    <main className="main-content">
      <div className="content-wrapper">
        <section className="text-content">
          <h1>Willkommen bei der Begleitplattform zur INCLASS App!</h1>
          <div className="project-info">
            {/* <h2>der Begleitplattform zur INCLASS App!</h2> */}
            <p>
            Die INCLASS App ermöglicht es Kindern, täglich Rückmeldung zu ihrem Schultag zu geben - etwa zu ihrem Wohlbefinden oder zu Hindernissen, 
            die sie erlebt haben. So werden Lehrkräfte und Eltern dabei unterstützt, Barrieren im Schulalltag autistischer (und nicht autistischer) Kinder zu erkennen. 
            </p>
            <p>
            Auf dieser Webseite können Sie die individuellen Ergebnisse einsehen, Muster erkennen und gemeinsam mit dem Kind 
            geeignete Unterstützungsmaßnahmen entwickeln, um die schulische Teilhabe des Kindes zu verbessern.
            </p>
          </div>
        </section>

        <div className="images-container">
          <img src={laptop} alt="Laptop" className="laptop-img" />
          {/* <img src={smartphone} alt="Smartphone" className="phone-img" /> */}
        </div>
      </div>
    </main>
  );
}

export default MainContent;